import { render } from "./ChronoPsiComponent.vue?vue&type=template&id=2a8ec624&scoped=true"
import script from "./ChronoPsiComponent.vue?vue&type=script&lang=js"
export * from "./ChronoPsiComponent.vue?vue&type=script&lang=js"

import "./ChronoPsiComponent.vue?vue&type=style&index=0&id=2a8ec624&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8ec624"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QLayout});
